<template>
    <div class="uk-margin-xlarge-bottom">
        <div class="uk-card uk-card-default uk-width-1-1 uk-margin-medium-bottom">
            <div class="uk-card-header">
                <div class="uk-grid-small uk-flex-middle" uk-grid>
                    <div class="uk-width-auto">
                        <img class="uk-border-circle" width="50" height="50" src="@/assets/biznow-logo.svg" alt="로고" uk-svg>
                    </div>
                    <div class="uk-width-expand">
                        <h3 class="uk-card-title uk-margin-remove-bottom">클라우드 비대면 솔루션 제작</h3>
                        <p class="uk-text-meta uk-margin-remove-top">
                            <time datetime="2023-01-01T19:00">2023년 1월 1일 ~ </time>
                            <time datetime="2023-07-01T19:00">2023년 7월 1일</time>
                        </p>
                    </div>
                    <div class="uk-width-auto">
                        <a href="/projectdetail" class="uk-button uk-button-text">상세 보기</a>
                    </div>
                </div>
            </div>
            <div class="uk-card-body">
                <p>
                    <div>진행 상황 : 30% <span class="uk-label" style="margin-bottom:3px">진행중</span><span class="uk-label uk-label-warning" style="margin-bottom:3px;margin-left:10px;">기획 단계</span></div>
                    <progress id="js-progressbar" class="uk-progress" value="30" max="100"></progress>
                </p>
            </div>
        </div>
        <div class="uk-card uk-card-default uk-width-1-1 uk-margin-medium-bottom">
            <div class="uk-card-header">
                <div class="uk-grid-small uk-flex-middle" uk-grid>
                    <div class="uk-width-auto">
                        <img class="uk-border-circle" width="50" height="50" src="@/assets/biznow-logo.svg" alt="로고" uk-svg>
                    </div>
                    <div class="uk-width-expand">
                        <h3 class="uk-card-title uk-margin-remove-bottom">병원용 미용/의료기기 펌웨어 개발 및 인증 대응(주 6시간 업무)</h3>
                        <p class="uk-text-meta uk-margin-remove-top">
                            <time datetime="2023-01-01T19:00">2023년 1월 1일 ~ </time>
                            <time datetime="2023-07-01T19:00">2023년 7월 1일</time>
                        </p>
                    </div>
                    <div class="uk-width-auto">
                        <a href="/projectdetail" class="uk-button uk-button-text">상세 보기</a>
                    </div>
                </div>
            </div>
            <div class="uk-card-body">
                <p>
                    <div>진행 상황 : 완료 <span class="uk-label uk-label-success" style="margin-bottom:3px">완료</span></div>
                    <progress id="js-progressbar" class="uk-progress" value="100" max="100"></progress>
                </p>
            </div>
            <div class="uk-card-footer">
                <button class="uk-button uk-button-text" uk-toggle="target: #modal-sections" type="button">운영 및 유지 보수 계약 작성</button>
            </div>
        </div>
        <div class="uk-card uk-card-default uk-width-1-1 uk-margin-medium-bottom">
            <div class="uk-card-header">
                <div class="uk-grid-small uk-flex-middle" uk-grid>
                    <div class="uk-width-auto">
                        <img class="uk-border-circle" width="50" height="50" src="@/assets/biznow-logo.svg" alt="로고" uk-svg>
                    </div>
                    <div class="uk-width-expand">
                        <h3 class="uk-card-title uk-margin-remove-bottom">크라우드 펀딩 앱 Android, iOS 네이티브 개발</h3>
                        <p class="uk-text-meta uk-margin-remove-top">
                            <time datetime="2023-01-01T19:00">2023년 1월 1일 ~ </time>
                            <time datetime="2023-07-01T19:00">2023년 7월 1일</time>
                        </p>
                    </div>
                    <div class="uk-width-auto">
                        <a href="/projectdetail" class="uk-button uk-button-text">상세 보기</a>
                    </div>
                </div>
            </div>
            <div class="uk-card-body">
                <p>
                    <div>진행 상황 : 75% <span class="uk-label" style="margin-bottom:3px">진행중</span><span class="uk-label uk-label-warning" style="margin-bottom:3px;margin-left:10px;">개발 단계</span></div>
                    <progress id="js-progressbar" class="uk-progress" value="70" max="100"></progress>
                </p>
            </div>
        </div>
        <div class="uk-card uk-card-default uk-width-1-1 uk-margin-medium-bottom">
            <div class="uk-card-header">
                <div class="uk-grid-small uk-flex-middle" uk-grid>
                    <div class="uk-width-auto">
                        <img class="uk-border-circle" width="50" height="50" src="@/assets/biznow-logo.svg" alt="로고" uk-svg>
                    </div>
                    <div class="uk-width-expand">
                        <h3 class="uk-card-title uk-margin-remove-bottom">인공지능 학습 데이터 검수 시스템 운영/유지보수(초반 ...</h3>
                        <p class="uk-text-meta uk-margin-remove-top">
                            <time datetime="2023-01-01T19:00">2023년 1월 1일 ~ </time>
                            <time datetime="2023-07-01T19:00">2023년 7월 1일</time>
                        </p>
                    </div>
                    <div class="uk-width-auto">
                        <a href="/projectdetail" class="uk-button uk-button-text">상세 보기</a>
                    </div>
                </div>
            </div>
            <div class="uk-card-body">
                <p>
                    <div>진행 상황 : 5% <span class="uk-label" style="margin-bottom:3px">진행중</span><span class="uk-label uk-label-warning" style="margin-bottom:3px;margin-left:10px;">수주 단계</span></div>
                    <progress id="js-progressbar" class="uk-progress" value="5" max="100"></progress>
                </p>
            </div>
        </div>
        <div class="uk-card uk-card-default uk-width-1-1 uk-margin-medium-bottom">
            <div class="uk-card-header">
                <div class="uk-grid-small uk-flex-middle" uk-grid>
                    <div class="uk-width-auto">
                        <img class="uk-border-circle" width="50" height="50" src="@/assets/biznow-logo.svg" alt="로고" uk-svg>
                    </div>
                    <div class="uk-width-expand">
                        <h3 class="uk-card-title uk-margin-remove-bottom">클라우드 기반의 차세대 공공 프로젝트 개발</h3>
                        <p class="uk-text-meta uk-margin-remove-top">
                            <time datetime="2023-01-01T19:00">2023년 1월 1일 ~ </time>
                            <time datetime="2023-07-01T19:00">2023년 7월 1일</time>
                        </p>
                    </div>
                    <div class="uk-width-auto">
                        <a href="/projectdetail" class="uk-button uk-button-text">상세 보기</a>
                    </div>
                </div>
            </div>
            <div class="uk-card-body">
                <p>
                    <div>진행 상황 : 55% <span class="uk-label uk-label-danger" style="margin-bottom:3px;margin-left:10px;">디자인 수정으로 인한 중지</span></div>
                    <progress id="js-progressbar" class="uk-progress" value="55" max="100"></progress>
                </p>
            </div>
            <div id="modal-sections" uk-modal>
                <div class="uk-modal-dialog">
                    <button class="uk-modal-close-default" type="button" uk-close></button>
                    <div class="uk-modal-header">
                        <h2 class="uk-modal-title">운영 및 유지 보수 계약</h2>
                    </div>
                    <div class="uk-modal-body">
                        <p>유지 보수 및 운영을 위한 상세 내용 기입</p>
                    </div>
                    <div class="uk-modal-footer uk-text-right">
                        <button class="uk-button uk-button-default uk-modal-close" type="button">취소</button>
                        <button class="uk-button uk-button-primary" type="button">확인</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.uk-card-title {
    font-size: 1.2rem;
}
</style>